<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e653">
<div class="tx38">
<p class="h11" id="d41151791"><a href="#/chap2_thegunse_9781569478004_epub_part2#d136761" id="d9t001-0"><b>PART ONE </b></a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap9_thegunse_9781569478004_epub_part9.vue?2afb4905